
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/community-guidelines",
      function () {
        return require("private-next-pages/terms/community-guidelines/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/community-guidelines"])
      });
    }
  